import { z } from 'zod'
import { EndDate, Id, IsActive, StartDate, UpdateDate } from './common-schemas'
import { GarItem } from './gar-item'

export namespace ParamType {
  export interface Data {
    /** @description Parameter type identifier (key) */
    readonly id: number

    /** @description Name */
    readonly name: string

    /** @description Code designation */
    readonly code: string

    /** @description Description */
    readonly desc?: string

    /** @description Record entry (update) date */
    readonly updateDate: Date

    /** @description Record validity start */
    readonly startDate: Date

    /** @description Record validity end */
    readonly endDate: Date

    /** @description Record action status */
    readonly isActive: boolean
  }
}

/** @description Information on parameter type */
export class ParamType extends GarItem<'ParamType', ParamType.Data> {
  static readonly SCHEMA: GarItem.Schema<ParamType.Data> = z
    .strictObject({
      ID: Id,

      NAME: z.string().describe('Name'),

      CODE: z.string().describe('Code designation'),

      DESC: z.string().describe('Description').optional(),

      UPDATEDATE: UpdateDate,

      STARTDATE: StartDate,

      ENDDATE: EndDate,

      ISACTIVE: IsActive,
    })
    .transform<ParamType.Data>(attributes => ({
      id: attributes.ID,
      name: attributes.NAME,
      code: attributes.CODE,
      desc: attributes.DESC,
      updateDate: attributes.UPDATEDATE,
      startDate: attributes.STARTDATE,
      endDate: attributes.ENDDATE,
      isActive: attributes.ISACTIVE,
    }))

  readonly type = 'ParamType'

  protected get schema() {
    return ParamType.SCHEMA
  }
}
